<template>
    <ui-card icon="fal fa-key" title="Autenticação">
        <template #body>
            <div class="area-card">
                <transition name="small-fade">
                    <div v-show="loading" class="loading-card">
                        <ui-load-indicator bg-color="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
                    </div>
                </transition>

                <div class="switch-container">
					<div class="ui-switch">
						<ui-switch 
							v-model="configData.enabled2FA"
							design="xs"
							:checked="configData.enabled2FA"
						/>
					</div>
                    <span>
						Habilite a autenticação de dois fatores para aumentar a segurança de acesso ao sistema.
					</span>
                </div>

				<div class="container-cards">
					<div class="input-card">
							<div class="centralize-text">
								<span>
									Por quantos minutos o código enviado por SMS ou E-mail será válido?
								</span>
							</div>
							<ui-input-number-stepper 
								v-model="configData.smsTimeValidPerMinute"
								input-text-color="#2084E5"
                :only-integer="true"
								:disabled="!configData.enabled2FA"
                :maxValue="1440"
                :minValue="1"
							/>
					</div>
					<div class="input-card second-input-card">
							<div class="centralize-text">
								<span>
									Quantas tentativas de validação do código será possível até haver bloqueios?
								</span>
							</div>
							<ui-input-number-stepper 
								v-model="configData.attemptsBeforeBlock"
                :only-integer="true"
								input-text-color="#2084E5" 
								:disabled="!configData.enabled2FA"
                :maxValue="60"
                :minValue="1"
							/>
					</div>
				</div>
                
            </div>
        </template>
        <template #fl/>
        <template #fr>
            <ui-button 
                design="md success" 
                :disabled="!canSubmit" 
                :loading="loading" 
                @click="submit">
                Salvar
            </ui-button>
        </template>
    </ui-card>
</template>

<script>
import { uiCard } from '@/components/ui/cards'
import { uiButton } from '@/components/ui/buttons'
import { uiInputNumberStepper, uiSwitch } from '@/components/ui/form';
import { uiLoadIndicator } from '@/components/ui';
import { permissionsMixin } from '@/mixins';
import { auth2FA } from '@/services/axios';
import { storage } from '@/services/storage'

export default {
  name: 'company-authentication',

  components: {
    uiCard,
    uiButton,
    uiSwitch,
    uiInputNumberStepper,
    uiLoadIndicator
  },

  mixins: [permissionsMixin],

  data() {
    return {
      loading: false,
      configData: {
        enabled2FA: false,
        smsTimeValidPerMinute: 5,
        attemptsBeforeBlock: 3
      },
      defaultForm: {
        enabled2FA: false,
        smsTimeValidPerMinute: 5,
        attemptsBeforeBlock: 3
      }
    }
  },

  computed: {
    canSubmit() {
      return JSON.stringify(this.configData) !== JSON.stringify(this.defaultForm)
    }
  },

  created() {
    const savedConfigs = JSON.parse(storage.get('get-configs-data')) || {}

    this.configData = {
      enabled2FA: savedConfigs['authAuthCodeEnabled'] === "1",
      smsTimeValidPerMinute: parseInt(savedConfigs['authAuthCodeDuration']) || 5,
      attemptsBeforeBlock: parseInt(savedConfigs['authAuthCodeAttempts']) || 3
    }

    this.defaultForm = JSON.parse(JSON.stringify(this.configData))
  },

  methods: {
    buildConfigurations() {
      return [
        {
          name: "authAuthCodeEnabled",
          value: this.configData.enabled2FA ? 1 : 0
        },
        {
          name: "authAuthCodeDuration",
          value: this.configData.smsTimeValidPerMinute
        },
        {
          name: "authAuthCodeAttempts",
          value: this.configData.attemptsBeforeBlock
        }
      ]
    },

    updateLocalStorage() {
      const currentStorage = JSON.parse(storage.get('get-configs-data')) || {}
      currentStorage["authAuthCodeEnabled"] = String(this.configData.enabled2FA ? 1 : 0)
      currentStorage["authAuthCodeDuration"] = String(this.configData.smsTimeValidPerMinute)
      currentStorage["authAuthCodeAttempts"] = String(this.configData.attemptsBeforeBlock)
      storage.set('get-configs-data', JSON.stringify(currentStorage))
    },

    async submit() {
      const payload = {
        configurations: this.buildConfigurations()
      }

      this.loading = true
      try {
        await auth2FA.saveConfigurations(payload)
        this.updateLocalStorage()
        this.defaultForm = JSON.parse(JSON.stringify(this.configData))
        this.$toastr.s('Configurações salvas com sucesso.')
      } catch (error) {
        this.$toastr.e('Erro ao salvar configurações.')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
